import styled from 'styled-components';

export const ScrollY = styled('div')`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
